export const CStickyDisclaimerFragments = {
    field: `
      fragment stickyDisclaimer on stickyDisclaimer_MatrixField {
        ... on stickyDisclaimer_block_Entry {
          id
          typeHandle
          disclaimerContent
          verticalAlignment
        }
      }
    `,
  }
